module.exports = __webpack_public_path__ + "img/pending-filled@3x.057dcc34.png";